(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-product"] && !Shopify.designMode) return;
  try {
    
function mountDeliveryNotes(root){
  const notes=root.querySelectorAll('.cav-delivery:not([data-delivery-ready])');
  notes.forEach(note=>{
    note.dataset.deliveryReady='true';
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{entry.target.classList.toggle('is-in-view',entry.isIntersecting);if(entry.isIntersecting){entry.target.classList.add('is-arrived');}});
    },{threshold:.5});
    observer.observe(note);
  });
}
mountDeliveryNotes(document);
document.addEventListener('shopify:section:load',event=>mountDeliveryNotes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(el){
    if(el.dataset.cavReady)return;
    var input=el.querySelector('.cav-ba__range'),control=el.querySelector('.cav-ba__control'),stage=el.querySelector('.cav-ba__frames');
    if(!input||!control||!stage)return;
    el.dataset.cavReady='1';
    var bl=el.dataset.bl||'Before',al=el.dataset.al||'After',drag=false;
    function set(v){v=Math.max(0,Math.min(100,Math.round(v)));if(String(v)!==input.value)input.value=v;el.style.setProperty('--cav-pos',v+'%');input.setAttribute('aria-valuetext',bl+' '+v+'%, '+al+' '+(100-v)+'%');}
    function pos(e){var r=stage.getBoundingClientRect();return r.width?(e.clientX-r.left)/r.width*100:+input.value;}
    input.addEventListener('input',function(){set(+input.value);});
    stage.addEventListener('pointerdown',function(e){if(e.pointerType==='mouse'&&e.button!==0)return;drag=true;try{stage.setPointerCapture(e.pointerId);}catch(x){}if(e.pointerType==='mouse')set(pos(e));});
    stage.addEventListener('pointermove',function(e){if(drag)set(pos(e));});
    ['pointerup','pointercancel','lostpointercapture'].forEach(function(t){stage.addEventListener(t,function(){drag=false;});});
    control.hidden=false;el.classList.add('is-enhanced');set(+input.value);
  }
  function all(root){(root||document).querySelectorAll('[data-cav-ba]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all();});else all();
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-flooring-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-flooring-hub')) {
    customElements.define('cavador-flooring-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.search = this.querySelector('[data-search]');
        this.material = this.querySelector('select[data-material]');
        this.series = this.querySelector('select[data-series]');
        this.colour = this.querySelector('select[data-colour]');
        this.sort = this.querySelector('select[data-sort]');
        this.size = this.querySelector('select[data-size]');
        this.thickness = this.querySelector('select[data-thickness]');
        this.activeFilters = this.querySelector('[data-active-filters]');
        this.colourPanel = this.querySelector('[data-colour-panel]');
        this.count = this.querySelector('[data-count]');
        this.empty = this.querySelector('[data-empty]');
        this.loadArea = this.querySelector('[data-load-area]');
        this.loadButton = this.querySelector('[data-load]');
        this.showing = this.querySelector('[data-showing]');
        this.colourChoices = this.querySelector('[data-colour-choices]');
        this.colourEmpty = this.querySelector('[data-colour-empty]');
        if (!this.grid || !this.search) return;
        this.limit = 24;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.collator = new Intl.Collator(this.dataset.locale || 'en', { numeric: true, sensitivity: 'base' });
        this.seriesAllLabel = this.series.options[0].textContent;
        this.colourAllLabel = this.colour.options[0].textContent;
        this.sizeAllLabel = this.size.options[0].textContent;
        this.thicknessAllLabel = this.thickness.options[0].textContent;
        this.materialLabels = new Map(Array.from(this.material.options).map(option => [option.value, option.textContent]));
        this.normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        this.records = this.cards.map((card, index) => {
          const colour = this.normaliseColour(card.dataset.colour, card.dataset.colourLabel);
          card.dataset.colour = colour.value;
          card.dataset.colourLabel = colour.label;
          const faceDimensions = String(card.dataset.dimensions || '').replace(/\([^)]*\)/g, '');
          const sizeLabel = faceDimensions.replace(/\s*[x×*]\s*/gi, ' × ').replace(/\s*mm$/i, ' mm').replace(/^RL up to /i, this.dataset.randomLengthLabel + ' ');
          const size = this.normalise(faceDimensions).replace(/[×*]/g, 'x').replace(/\s+/g, '');
          const dimensionParts = String(card.dataset.dimensions || '').split(/[x×*]/i);
          const totalThickness = dimensionParts.length >= 3 ? parseFloat(dimensionParts[2]) : parseFloat(card.dataset.thickness);
          return {
            size, sizeLabel, card, index, title: card.dataset.title || '', material: card.dataset.material || '',
            series: card.dataset.series || '', seriesLabel: card.dataset.seriesLabel || '',
            colour: colour.value, colourLabel: colour.label,
            image: card.querySelector('.cfh__card-image img')?.getAttribute('src') || '',
            thickness: totalThickness,
            search: this.normalise([card.dataset.title, card.dataset.model, String(card.dataset.model || '').replace(/[\s_-]/g, ''), card.dataset.seriesLabel, colour.label, card.dataset.material, card.dataset.dimensions, size, card.dataset.thickness].join(' '))
          };
        });
        const materials = Array.from(new Set(this.records.map(record => record.material).filter(Boolean)));
        this.defaultMaterial = materials.length === 1 ? materials[0] : '';
        const seriesValues = Array.from(new Set(this.records.map(record => record.series).filter(Boolean)));
        this.defaultSeries = this.dataset.scope !== 'all-flooring' && seriesValues.length === 1 ? seriesValues[0] : '';
        if (this.defaultMaterial) this.material.closest('.cfh__field').hidden = true;
        if (this.dataset.scope === 'all-flooring') {
          this.querySelectorAll('[data-material-count]').forEach(element => {
            element.textContent = this.records.filter(record => record.material === element.dataset.materialCount).length;
          });
        }
        this.restore();
        this.updateOptions();
        this.bind();
        this.classList.add('is-ready');
        if (!this.reduceMotion.matches && 'IntersectionObserver' in window) {
          this.classList.add('cfh--motion');
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                this.observer.unobserve(entry.target);
              }
            });
          }, { rootMargin: '80px', threshold: 0.04 });
        }
        this.apply(false);
        this.setupFilterPanel();
        this.setupStudioComparison();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.studioComparisonAnimations?.forEach(animation => animation.cancel());
        this.initialized = false;
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.searchTimer);
      }
      setupStudioComparison() {
        const studio = this.querySelector('.cfh__studio');
        const after = studio?.querySelector('.cfh__studio-after');
        const divider = studio?.querySelector('.cfh__studio-divider');
        const images = Array.from(studio?.querySelectorAll('.cfh__studio-comparison img') || []);
        if (!after || !divider || typeof after.animate !== 'function') return;
        this.studioComparisonAnimations = [];
        const play = () => {
          if (this.reduceMotion.matches || images.some(image => !image.complete || !image.naturalWidth)) return;
          this.studioComparisonAnimations.forEach(animation => animation.cancel());
          const options = { duration: 4600, easing: 'ease-in-out', iterations: 1 };
          const positions = [{ percent: 50, offset: 0 }, { percent: 25, offset: .3 }, { percent: 75, offset: .72 }, { percent: 50, offset: 1 }];
          this.studioComparisonAnimations = [
            after.animate(positions.map(position => ({ clipPath: `inset(0 0 0 ${position.percent}%)`, offset: position.offset })), options),
            divider.animate(positions.map(position => ({ left: `${position.percent}%`, offset: position.offset })), options)
          ];
        };
        studio.addEventListener('pointerenter', play, { signal: this.abort.signal });
        studio.addEventListener('focusin', event => { if (!studio.contains(event.relatedTarget)) play(); }, { signal: this.abort.signal });
        images.forEach(image => image.addEventListener('load', play, { once: true, signal: this.abort.signal }));
        this.reduceMotion.addEventListener('change', () => { if (this.reduceMotion.matches) this.studioComparisonAnimations.forEach(animation => animation.cancel()); }, { signal: this.abort.signal });
        play();
      }
      normaliseColour(value, label) {
        const isModelCode = text => /^TF[A-Z]*\d+[A-Z0-9]*$/i.test(String(text || '').replace(/[\s_-]/g, ''));
        if (isModelCode(value) || isModelCode(label)) return { value: '', label: '' };
        return {
          value: this.normalise(value).replace(/\bbiege\b/g, 'beige'),
          label: String(label || '').trim().replace(/\bbiege\b/gi, 'Beige')
        };
      }
      restore() {
        const params = new URL(window.location.href).searchParams;
        this.material.value = this.defaultMaterial;
        this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.sort.value = 'featured';
        this.search.value = params.get('cfh_q') || '';
        const material = this.defaultMaterial || params.get('cfh_material') || '';
        if (Array.from(this.material.options).some(option => option.value === material)) this.material.value = material;
        this.restoredSeries = params.get('cfh_series') || this.defaultSeries;
        this.restoredColour = (params.get('cfh_colour') || '').replace(/\bbiege\b/gi, 'beige');
        this.restoredSize = params.get('cfh_size') || '';
        this.restoredThickness = params.get('cfh_thickness') || ''; 
        const sort = params.get('cfh_sort') || 'featured';
        if (Array.from(this.sort.options).some(option => option.value === sort)) this.sort.value = sort;
      }
      updateOptions() {
        const materialRecords = this.records.filter(record => !this.material.value || record.material === this.material.value);
        const rebuild = (select, records, key, labelKey, allLabel, restored) => {
          const previous = restored || select.value;
          const values = new Map();
          records.forEach(record => { if (record[key]) values.set(record[key], record[labelKey] || record[key]); });
          select.replaceChildren(new Option(allLabel, ''));
          Array.from(values.entries()).sort((a,b) => this.collator.compare(a[1], b[1])).forEach(([value,label]) => select.add(new Option(label, value)));
          if (values.has(previous)) select.value = previous;
        };
        rebuild(this.series, materialRecords, 'series', 'seriesLabel', this.seriesAllLabel, this.restoredSeries);
        const collectionRecords = materialRecords.filter(record => !this.series.value || record.series === this.series.value);
        rebuild(this.colour, collectionRecords, 'colour', 'colourLabel', this.colourAllLabel, this.restoredColour);
        const colourRecords = collectionRecords.filter(record => !this.colour.value || record.colour === this.colour.value);
        rebuild(this.size, colourRecords, 'size', 'sizeLabel', this.sizeAllLabel, this.restoredSize);
        const sizeRecords = colourRecords.filter(record => !this.size.value || record.size === this.size.value);
        const thicknessRecords = sizeRecords.filter(record => Number.isFinite(record.thickness)).map(record => ({ thicknessKey: String(record.thickness), thicknessLabel: record.thickness + ' mm' }));
        rebuild(this.thickness, thicknessRecords, 'thicknessKey', 'thicknessLabel', this.thicknessAllLabel, this.restoredThickness);
        this.size.disabled = this.size.options.length < 2;
        this.thickness.disabled = this.thickness.options.length < 2;
        this.restoredSeries = ''; this.restoredColour = ''; this.restoredSize = ''; this.restoredThickness = '';
        this.renderChoices(collectionRecords);
      }
      finishCount(count) {
        return (count === 1 ? this.dataset.countOneTemplate : this.dataset.countTemplate).replace('__COUNT__', count);
      }
      choiceImage(record, container) {
        const image = document.createElement('img');
        const source = new URL(record.image, window.location.href);
        if (source.hostname === 'cdn.shopify.com' || source.pathname.startsWith('/cdn/shop/')) source.searchParams.set('width', '320');
        image.src = source.href;
        image.alt = '';
        image.width = 160;
        image.height = 160;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.className = 'cfh__choice-image';
        container.append(image);
      }
      choiceText(className, text) {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        return span;
      }
      renderChoices(collectionRecords) {
        const focusedColour = this.colourChoices.querySelector(':focus')?.dataset.colourChoice;
        this.colourPanel.hidden = !this.series.value;
        const colours = new Map();
        collectionRecords.forEach(record => {
          if (!record.colour) return;
          if (!colours.has(record.colour)) colours.set(record.colour, []);
          colours.get(record.colour).push(record);
        });
        const colourFragment = document.createDocumentFragment();
        Array.from(colours.entries()).sort((a,b) => this.collator.compare(a[1][0].colourLabel, b[1][0].colourLabel)).forEach(([value, records]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cfh__colour-choice';
          button.dataset.colourChoice = value;
          button.setAttribute('aria-pressed', String(this.colour.value === value));
          const image = document.createElement('span');
          image.className = 'cfh__colour-image';
          const example = records.find(record => record.image);
          if (example) this.choiceImage(example, image);
          else image.append(this.choiceText('cfh__choice-no-image', this.dataset.noImageLabel));
          const copy = document.createElement('span');
          copy.className = 'cfh__colour-copy';
          copy.append(this.choiceText('cfh__colour-name', records[0].colourLabel || value));
          copy.append(this.choiceText('cfh__choice-count', this.finishCount(records.length)));
          button.append(image, copy);
          colourFragment.append(button);
        });
        this.colourChoices.replaceChildren(colourFragment);
        this.colourChoices.hidden = colours.size === 0;
        this.colourEmpty.hidden = colours.size > 0;
        if (focusedColour) Array.from(this.colourChoices.children).find(button => button.dataset.colourChoice === focusedColour)?.focus({ preventScroll: true });
      }
      bind() {
        const options = { signal: this.abort.signal };
        this.querySelector('[data-filter-form]').addEventListener('submit', event => event.preventDefault(), options);
        this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => { this.limit = 24; this.apply(); }, 160);
        }, options);
        this.material.addEventListener('change', () => { this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.updateOptions(); this.limit = 24; this.apply(); }, options);
        this.series.addEventListener('change', () => {
          if (this.series.value && !this.defaultMaterial) this.material.value = this.records.find(record => record.series === this.series.value)?.material || '';
          this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.updateOptions(); this.limit = 24; this.apply();
        }, options);
        [this.colour, this.size].forEach(select => select.addEventListener('change', () => { this.updateOptions(); this.limit = 24; this.apply(); }, options));
        [this.thickness, this.sort].forEach(select => select.addEventListener('change', () => { this.limit = 24; this.apply(); }, options));
        this.colourChoices.addEventListener('click', event => {
          const button = event.target.closest('[data-colour-choice]');
          if (!button) return;
          this.colour.value = this.colour.value === button.dataset.colourChoice ? '' : button.dataset.colourChoice;
          this.updateOptions(); this.limit = 24; this.apply();
        }, options);
        this.querySelectorAll('[data-clear]').forEach(button => button.addEventListener('click', () => {
          this.search.value = ''; this.material.value = this.defaultMaterial; this.series.value = this.defaultSeries; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.sort.value = 'featured'; this.limit = 24;
          this.updateOptions(); this.apply(); this.search.focus({ preventScroll: true });
        }, options));
        this.querySelectorAll('[data-material-choice]').forEach(button => button.addEventListener('click', event => {
          if (this.dataset.scope !== 'all-flooring' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.material.value = button.dataset.materialChoice;
          this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.limit = 24;
          this.updateOptions(); this.apply();
        }, options));
        this.activeFilters.addEventListener('click', event => {
          const button = event.target.closest('[data-remove-filter]');
          if (!button) return;
          this[button.dataset.removeFilter].value = button.dataset.removeFilter === 'material' ? this.defaultMaterial : button.dataset.removeFilter === 'sort' ? 'featured' : '';
          if (button.dataset.removeFilter === 'material') { this.series.value = ''; this.colour.value = ''; }
          if (button.dataset.removeFilter === 'series') this.colour.value = '';
          this.updateOptions(); this.limit = 24; this.apply();
          (this.activeFilters.querySelector('button') || this.search).focus({ preventScroll: true });
        }, options);
        this.loadButton.addEventListener('click', () => { this.limit += 24; this.apply(false); }, options);
        window.addEventListener('popstate', () => { this.restore(); this.updateOptions(); this.limit = 24; this.apply(false); }, options);
      }
      apply(updateUrl = true) {
        const words = this.normalise(this.search.value).replace(/[×*]/g, 'x').split(/\s+/).filter(Boolean);
        const matches = this.records.filter(record =>
          (!this.material.value || record.material === this.material.value) &&
          (!this.series.value || record.series === this.series.value) &&
          (!this.colour.value || record.colour === this.colour.value) &&
          (!this.size.value || record.size === this.size.value) &&
          (!this.thickness.value || String(record.thickness) === this.thickness.value) &&
          words.every(word => record.search.includes(word))
        );
        const sort = this.sort.value;
        matches.sort((a,b) => {
          if (sort === 'title-ascending') return this.collator.compare(a.title, b.title);
          if (sort === 'title-descending') return this.collator.compare(b.title, a.title);
          if (sort.startsWith('thickness-')) {
            const aValid = Number.isFinite(a.thickness), bValid = Number.isFinite(b.thickness);
            if (!aValid) return bValid ? 1 : a.index - b.index;
            if (!bValid) return -1;
            return (sort === 'thickness-ascending' ? a.thickness - b.thickness : b.thickness - a.thickness) || this.collator.compare(a.title,b.title);
          }
          return a.index - b.index;
        });
        this.cards.forEach(card => { card.hidden = true; });
        const fragment = document.createDocumentFragment();
        matches.forEach((record,index) => {
          record.card.hidden = index >= this.limit;
          fragment.append(record.card);
          if (!record.card.hidden && this.observer) this.observer.observe(record.card);
        });
        this.grid.append(fragment);
        const visible = Math.min(this.limit, matches.length);
        const countTemplate = matches.length === 1 ? this.dataset.countOneTemplate : this.dataset.countTemplate;
        this.count.textContent = countTemplate.replace('__COUNT__', matches.length);
        this.empty.hidden = matches.length > 0;
        this.loadArea.hidden = matches.length === 0;
        this.loadButton.hidden = visible >= matches.length;
        const showingTemplate = matches.length === 1 ? this.dataset.showingOneTemplate : this.dataset.showingTemplate;
        this.showing.textContent = showingTemplate.replace('__COUNT__', visible).replace('__TOTAL__', matches.length);
        const hasFilters = Boolean(this.search.value || this.material.value !== this.defaultMaterial || this.series.value !== this.defaultSeries || this.colour.value || this.size.value || this.thickness.value || this.sort.value !== 'featured');
        this.querySelectorAll('[data-clear]').forEach(button => { button.disabled = !hasFilters; });
        this.querySelectorAll('[data-material-choice]').forEach(button => {
          if (this.material.value === button.dataset.materialChoice) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.colourChoices.querySelectorAll('[data-colour-choice]').forEach(button => button.setAttribute('aria-pressed', String(this.colour.value === button.dataset.colourChoice)));
        this.renderActiveFilters();
        if (updateUrl) {
          const url = new URL(window.location.href);
          const state = { cfh_q: this.search.value.trim(), cfh_material: this.material.value === this.defaultMaterial ? '' : this.material.value, cfh_series: this.series.value === this.defaultSeries ? '' : this.series.value, cfh_colour: this.colour.value, cfh_size: this.size.value, cfh_thickness: this.thickness.value, cfh_sort: this.sort.value === 'featured' ? '' : this.sort.value };
          Object.entries(state).forEach(([key,value]) => { if (value) url.searchParams.set(key,value); else url.searchParams.delete(key); });
          history.replaceState(history.state, '', url);
        }
      }
      renderActiveFilters() {
        const fragment = document.createDocumentFragment();
        ['material', 'series', 'colour', 'size', 'thickness', 'search', 'sort'].forEach(key => {
          const control = this[key];
          if (!control.value || (key === 'material' && control.value === this.defaultMaterial) || (key === 'series' && control.value === this.defaultSeries) || (key === 'sort' && control.value === 'featured')) return;
          const label = key === 'search' ? '“' + control.value + '”' : control.selectedOptions[0].textContent;
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'cfh__filter-chip'; button.dataset.removeFilter = key;
          button.textContent = label + ' ×'; button.setAttribute('aria-label', this.dataset.removeLabel + ' ' + label);
          fragment.append(button);
        });
        this.activeFilters.replaceChildren(fragment);
      }
      setupFilterPanel() {
        const panel = this.querySelector('[data-filter-panel]');
        const summary = panel.querySelector('summary');
        const mobile = window.matchMedia('(max-width: 1024px)');
        const options = { signal: this.abort.signal };
        const sync = () => { panel.open = !mobile.matches; };
        sync();
        mobile.addEventListener('change', sync, options);
        summary.addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); }, options);
        this.querySelector('[data-close-filters]').addEventListener('click', () => {
          if (!mobile.matches) return;
          panel.open = false;
          summary.focus({ preventScroll: true });
        }, options);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-flooring-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cavador-flooring-product')) {
  customElements.define('cavador-flooring-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.words = JSON.parse(this.querySelector('[data-translations]').textContent);
      this.coverage = Number(this.dataset.coverage);
      this.currency = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency });
      this.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => {
        const media = document.getElementById(button.dataset.mediaTarget);
        if (media) this.querySelector('[data-gallery]').scrollTo({ left: media.offsetLeft - this.querySelector('[data-gallery]').offsetLeft });
      }));
      this.querySelector('[data-variant-select]')?.addEventListener('change', event => this.selectVariant(event.target.value));
      this.querySelector('[data-area]')?.addEventListener('input', () => this.calculate());
      this.querySelector('[data-extra]')?.addEventListener('input', () => this.calculate());
      this.querySelector('[data-use-calculation]')?.addEventListener('click', () => {
        const quantity = this.querySelector('[data-quantity]');
        if (quantity && this.calculatedBoxes > 0) { quantity.value = this.calculatedBoxes; quantity.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      this.querySelector('form')?.addEventListener('submit', event => {
        const id = this.querySelector('[data-variant-id]')?.value;
        const variant = this.variants.find(value => String(value.id) === String(id));
        if (!variant || variant.price <= 0 || !variant.available) event.preventDefault();
      });
    }
    selectVariant(id) {
      const variant = this.variants.find(value => String(value.id) === String(id));
      if (!variant) return;
      const pending = variant.price <= 0;
      this.querySelector('[data-box-price]').textContent = pending ? this.words.pending : `${this.currency.format(variant.price / 100)} ${this.words.perBox}`;
      const areaPrice = this.querySelector('[data-area-price]');
      areaPrice.hidden = pending || !(this.coverage > 0);
      if (!areaPrice.hidden) areaPrice.textContent = `${this.currency.format(variant.price / 100 / this.coverage)} ${this.words.perSqft}`;
      this.querySelector('[data-current-sku]').textContent = variant.sku || '';
      const hiddenId = this.querySelector('[data-variant-id]');
      if (hiddenId) hiddenId.value = variant.id;
      const purchase = this.querySelector('[data-purchase]');
      if (purchase) purchase.hidden = pending;
      const add = this.querySelector('[data-add]');
      if (add) { add.disabled = pending || !variant.available; add.textContent = variant.available && !pending ? this.words.add : this.words.soldOut; }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      if (this.querySelector('[data-area]')) this.calculate();
    }
    calculate() {
      const area = Number(this.querySelector('[data-area]').value);
      const extra = Number(this.querySelector('[data-extra]').value);
      const valid = Number.isFinite(area) && area > 0 && Number.isFinite(extra) && extra >= 0 && extra <= 100 && this.coverage > 0;
      this.calculatedBoxes = valid ? Math.ceil(area * (1 + extra / 100) / this.coverage) : 0;
      this.querySelector('[data-calculation]').textContent = valid ? this.words.boxResult.replace('[boxes]', String(this.calculatedBoxes)).replace('[coverage]', new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 2 }).format(this.calculatedBoxes * this.coverage)) : '';
      this.querySelector('[data-use-calculation]').hidden = !valid || !this.querySelector('[data-quantity]') || this.querySelector('[data-purchase]').hidden;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-installation-film"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!customElements.get('cavador-editorial-film')){
    class CavadorEditorialFilm extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.video=this.querySelector('video');
        this.button=this.querySelector('[data-editorial-play]');
        this.error=this.querySelector('[data-editorial-error]');
        if(!this.video||!this.button)return;
        this.controller=new AbortController();
        this.requestId=(this.requestId||0)+1;
        this.autoEnabled=this.dataset.autoplay!=='false';
        this.userPaused=this.userPaused===true;
        this.manualPlayback=this.manualPlayback===true;
        this.controlsRequested=this.controlsRequested===true;
        this.pointerOver=false;
        this.pageHidden=false;
        this.inView=false;
        this.managedPauseEvents=0;
        var options={signal:this.controller.signal};
        if(!this.everConnected){this.video.muted=true;this.everConnected=true;}
        this.video.loop=true;
        this.video.autoplay=false;
        this.video.controls=this.controlsRequested;
        this.button.hidden=false;
        this.motionQuery=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
        this.reducedMotion=Boolean(this.motionQuery?.matches);
        this.motionChanged=()=>{this.reducedMotion=Boolean(this.motionQuery.matches);this.sync();};
        if(this.motionQuery?.addEventListener)this.motionQuery.addEventListener('change',this.motionChanged,options);
        else this.motionQuery?.addListener(this.motionChanged);
        this.button.addEventListener('click',()=>this.toggle(),options);
        this.video.addEventListener('play',()=>this.onPlay(),options);
        this.video.addEventListener('pause',()=>this.onPause(),options);
        this.video.addEventListener('ended',()=>this.update(),options);
        this.video.addEventListener('volumechange',()=>{
          if(this.audible()&&!this.video.paused){this.audioBlocked=false;this.claimAudio();}
          else if(!this.audible()){this.audioBlocked=false;this.sync();}
        },options);
        this.video.addEventListener('pointerenter',()=>{this.pointerOver=true;this.update();},options);
        this.video.addEventListener('pointerleave',()=>{this.pointerOver=false;this.update();},options);
        this.video.addEventListener('focusin',()=>this.update(),options);
        this.video.addEventListener('focusout',()=>this.update(),options);
        this.video.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){this.controlsRequested=true;this.update();}this.allowNativeStart();},options);
        this.video.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter')this.allowNativeStart();},options);
        this.video.addEventListener('error',()=>this.showError(),options);
        document.addEventListener('cavador:acoustic-play',event=>{
          if(event.detail!==this&&this.audible()){this.audioBlocked=true;this.pauseManaged();}
        },options);
        document.addEventListener('visibilitychange',()=>this.sync(),options);
        window.addEventListener('pagehide',()=>{this.pageHidden=true;this.pauseManaged();},options);
        window.addEventListener('pageshow',()=>{this.pageHidden=false;this.sync();},options);
        if(window.IntersectionObserver){
          this.observer=new IntersectionObserver(entries=>{
            entries.forEach(entry=>{if(entry.target===this.video){this.inView=entry.isIntersecting&&entry.intersectionRatio!==0;this.sync();}});
          },{threshold:0.01});
          this.observer.observe(this.video);
        }else{
          this.viewChanged=()=>{var rect=this.video.getBoundingClientRect();this.inView=rect.bottom>0&&rect.top<window.innerHeight&&rect.width>0&&rect.height>0;this.sync();};
          window.addEventListener('scroll',this.viewChanged,{...options,passive:true});
          window.addEventListener('resize',this.viewChanged,options);
          this.viewChanged();
        }
        this.update();
      }
      disconnectedCallback(){
        this.pauseManaged();
        this.observer?.disconnect();
        if(!this.motionQuery?.removeEventListener)this.motionQuery?.removeListener(this.motionChanged);
        this.controller?.abort();
        this.controller=null;
      }
      audible(){return !this.video.muted&&this.video.volume>0;}
      eligible(){
        return this.isConnected&&this.inView&&!this.pageHidden&&document.visibilityState!=='hidden'&&!this.userPaused&&
          (this.manualPlayback||(this.autoEnabled&&!this.reducedMotion&&!this.autoBlocked))&&(!this.audioBlocked||!this.audible());
      }
      sync(){
        if(!this.video)return;
        if(!this.eligible()){this.pauseManaged();return;}
        if(this.video.paused&&(!this.pendingPlay||this.pendingPlay.canceled))this.start(false);
        this.update();
      }
      async start(manual){
        if(!this.eligible())return;
        if(this.video.ended)this.video.currentTime=0;
        var request=++this.requestId;
        var pending={request:request,canceled:false};
        this.pendingPlay=pending;
        this.clearError();
        this.video.autoplay=!manual&&!this.manualPlayback&&this.autoEnabled&&!this.reducedMotion;
        this.video.controls=this.controlsRequested;
        try{
          await this.video.play();
          if(this.pendingPlay===pending&&(pending.canceled||!this.eligible()))this.pauseManaged();
        }catch(error){
          if(request===this.requestId&&this.isConnected&&!pending.canceled&&error.name!=='AbortError'){
            if(manual)this.showError();
            else{this.autoBlocked=true;this.video.autoplay=false;}
          }
        }finally{if(this.pendingPlay===pending)this.pendingPlay=null;}
        this.update();
      }
      toggle(){
        if(!this.video.paused&&!this.video.ended){
          this.userPaused=true;this.manualPlayback=false;this.pauseManaged();return;
        }
        this.userPaused=false;this.manualPlayback=true;this.autoBlocked=false;this.audioBlocked=false;this.controlsRequested=true;
        return this.start(true);
      }
      pauseManaged(){
        this.requestId=(this.requestId||0)+1;
        if(this.pendingPlay)this.pendingPlay.canceled=true;
        if(this.video){
          this.video.autoplay=false;
          if(!this.video.paused)this.managedPauseEvents=(this.managedPauseEvents||0)+1;
          this.video.pause();
        }
        this.update();
      }
      onPlay(){
        if(this.video.paused)return;
        if(this.pendingPlay?.canceled||!this.eligible()){this.pauseManaged();return;}
        this.video.controls=this.controlsRequested;
        this.clearError();this.update();
        if(this.audible())this.claimAudio();
      }
      onPause(){
        if(this.managedPauseEvents>0){this.managedPauseEvents-=1;this.update();return;}
        if(!this.video.paused)return;
        if(this.pendingPlay?.canceled){this.update();return;}
        if(!this.isConnected||!this.inView||this.pageHidden||document.visibilityState==='hidden'){this.update();return;}
        this.userPaused=true;this.manualPlayback=false;
        this.requestId+=1;
        if(this.pendingPlay)this.pendingPlay.canceled=true;
        this.video.autoplay=false;
        this.update();
      }
      claimAudio(){document.dispatchEvent(new CustomEvent('cavador:acoustic-play',{detail:this}));}
      allowNativeStart(){
        if(!this.video.controls)return;
        if(this.video.paused){
          this.requestId+=1;this.pendingPlay=null;this.userPaused=false;this.manualPlayback=true;this.autoBlocked=false;this.audioBlocked=false;
        }
      }
      update(){
        if(!this.video||!this.button)return;
        var playing=!this.video.paused&&!this.video.ended;
        if(playing&&document.activeElement===this.button)this.video.focus({preventScroll:true});
        this.button.hidden=playing;
        this.video.controls=this.controlsRequested||(!this.classList.contains('cav-film--full-bleed')&&this.pointerOver)||this.video.matches(':focus-within');
        var label=this.video.ended?this.dataset.replayLabel:this.dataset.playLabel;
        this.button.querySelector('span').textContent=label;
        this.button.setAttribute('aria-label',label);
      }
      clearError(){if(this.error){this.error.hidden=true;this.error.textContent='';}}
      showError(){if(this.error){this.error.textContent=this.dataset.errorLabel;this.error.hidden=false;}}
    }
    customElements.define('cavador-editorial-film',CavadorEditorialFilm);
  }
  function setup(el){
    if(el.dataset.cfReady)return;
    var v=el.querySelector('video'),play=el.querySelector('.cav-film__play');
    if(!v||!play)return;
    el.dataset.cfReady='1';
    function show(){var f=document.activeElement===v;el.classList.remove('is-playing');el.querySelector('.cav-film__overlay').inert=false;v.controls=false;if(f)play.focus({preventScroll:true});}
    function hide(){el.classList.add('is-playing');v.controls=true;el.querySelector('.cav-film__overlay').inert=true;v.focus({preventScroll:true});}
    function start(t){
      function go(){if(t!=null){try{v.currentTime=Math.max(0,Math.min(t,Number.isFinite(v.duration)?Math.max(0,v.duration-.1):t));}catch(e){}}var p=v.play();if(p&&p.catch)p.catch(show);}
      if(t!=null&&v.readyState<1){v.preload='metadata';v.addEventListener('loadedmetadata',go,{once:true});v.load();}else go();
    }
    v.addEventListener('play',hide);
    v.addEventListener('ended',show);
    play.addEventListener('click',function(){start(null);});
    el.querySelectorAll('[data-start]').forEach(function(b){b.addEventListener('click',function(){start(parseFloat(b.dataset.start)||0);});});
    v.controls=false;
    el.querySelectorAll('[data-cf-js]').forEach(function(n){n.hidden=false;});
    el.classList.add('is-enhanced');
  }
  function all(r){(r||document).querySelectorAll('[data-cav-film]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all();});else all();
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
